<template>
    <div class="TheMode">
        <el-carousel :style="{ height: innerheight + 'px' }"
                     :interval="3000"
                     arrow="always">
            <el-carousel-item v-for="(item, index) in list"
                              :key="index">
                <img class="banner"
                     @click="handleSelect(item)"
                     v-bind:src="item.image" />
            </el-carousel-item>
        </el-carousel>
        <div class="TheModeA">
            <el-row type="flex"
                    class="row-bg absout"
                    justify="center">
                <el-col class="frame"
                        :class="
                        this.recordlist.length !== 0 && this.recordheight > 47
                            ? ''
                            : 'frameshouqi'
                    ">
                    <el-form :model="ruleForm"
                             :style="{ margin: topheight + 'px' }"
                             ref="ruleForm"
                             :rules="rules"
                             label-width="0"
                             class="demo-ruleForm">
                        <el-form-item prop="inputValue">
                            <el-col class="fields"
                                    :style="{ height: recordheight + 'px' }">
                                <div class="bground"
                                     :class="
                                        this.recordheight > 47
                                            ? ''
                                            : 'bgroundshouqi'
                                    ">
                                    <!-- <el-tag v-show="recoded"
                                            :key="tag"
                                            size="mini"
                                            v-for="(tag, index) in dynamicTags"
                                            :closable="activeIndex !== index"
                                            ref="inputtag"
                                            class="green"
                                            :disable-transitions="true"
                                            @close="handleClose(tag, index)">
                                        <span v-if="activeIndex !== index"
                                              @click="edittag(tag, index)">{{ tag }}</span>
                                        <input class="inputtext"
                                               type="text"
                                               autofocus
                                               ref="saveInputtext"
                                               v-if="activeIndex == index"
                                               v-model="inputhtml"
                                               @blur="save" />
                                    </el-tag> -->

                                    <el-input v-if="recordheight == 47"
                                              class="recodecord"
                                              type="textarea"
                                              v-show="this.dynamicTags.length !== 10"
                                              v-on:keyup.186.native="
                                            handleInputConfirm
                                        "
                                              placeholder="请输入运单号（12-15位），最多可输入10条"
                                              @focus="recordenlarge()"></el-input>
                                    <el-input v-else
                                              :class="recordheight > 47
                                                ? 'recordcode'
                                                : 'recodecord'
                                        "
                                              ref="saveTagInput"
                                              autofocus
                                              style="resize:none"
                                              type="textarea"
                                              v-model="ruleForm.inputValue"
                                              @blur="original"
                                              v-on:keyup.enter.native="
                                            submitForm('ruleForm')
                                        "
                                              placeholder="在此输入"
                                              @focus="recordenlarge()"></el-input>
                                </div>
                            </el-col>
                            <el-col class="inlined"
                                    :style="{ height: recordheight + 'px' }">
                                <el-button class="beautiful btn"
                                           @click="submitForm('ruleForm')"
                                           type="primary"><span class="yimidida">发物流 找壹米滴答</span>
                                    <i class="el-icon-caret-right"></i></el-button>
                            </el-col>
                        </el-form-item>
                    </el-form>
                    <div class="record"
                         v-if="
                            this.recordlist.length !== 0 &&
                                this.recordheight > 47
                        ">
                        <span>查询记录 : </span>

                        <p>
                            <el-tag :key="tag"
                                    v-for="tag in recordlist"
                                    closable
                                    :disable-transitions="true"
                                    @close="recordhandleClose(tag)">
                                <span @click="outin(tag)"> {{ tag }}</span>
                            </el-tag>
                        </p>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row type="flex"
                class="row-bg line"
                justify="center">
            <el-col :span="4"
                    v-for="item in textmain"
                    :key="item.index">
                <div class="ico"
                     @click="jumpPage(item)">
                    <div class="bann">
                        <img class="iconimage"
                             :src="item.image" />
                        <img class="hoverimage"
                             :src="item.bottomImg" />
                    </div>

                    <span class="inLine">{{ item.title }}</span>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import Cookies from "js-cookie";
import { menuqueryaddressid } from "@/api/menu";
import { homebannerquery, homeAction } from "@/api/homePage";
import Swiper from "swiper";
import "swiper/dist/css/swiper.css";
import "swiper/dist/js/swiper.min.js";
export default {
    data() {
        return {
            textmain: [],
            recordlist: [],
            dynamicTags: [],
            recordshow: false,
            display: {
                title: "",
                image: "",
                images: "",
                demoFlag: "",
                id: "",
                urlMenu: ""
            },
            inputhtml: "",
            i: 0,
            displaylist: [],

            recoded: false,
            inpheightTimeout: null,
            disabled: false,
            topheight: 15,
            innerheight: "",
            editing: false,
            codeheight: 47,
            recordheight: 47,
            ruleForm: {
                inputValue: ""
            },
            dom: "",
            bannerH: 0,
            bannerHeight: 1040,
            screenWidth: 1920,
            list: [],
            activeIndex: 11,
            tagsinnernum: "",
            routerUrl: "",
            rules: {
                inputValue: [
                    {
                        required: false,
                        message: "请输入单号或电话给号码",
                        trigger: "blur"
                    }
                ]
            }
        };
    },
    created() {
        this.bannerquery();
        this.homeActionquery();
        this.clienheight();
        if (Cookies.get("Waybilllist")) {
            this.recordlist = Cookies.get("Waybilllist").split(",");
        } else {
            this.recordlist = [];
        }
    },
    // watch: {
    //     "ruleForm.inputValue"() {
    //         if (this.ruleForm.inputValue.length == 12) {
    //             this.watchInputblur();
    //         } else {
    //             this.duplicateoddnumber();
    //         }
    //     }
    // },
    mounted() {
        this.aueryfindbytype();
        const that = this;
        //监听浏览器窗口大小改变
        window.addEventListener(
            "resize",
            function () {
                var width =
                    window.innerWidth ||
                    document.documentElement.clientWidth ||
                    document.body.clientWidth;
                that.screenWidth = width;
                that.setSize();
            },
            false
        );
    },
    methods: {
        // 数组去重
        duplicateoddnumber() {
            let newnumber = this.ruleForm.inputValue;

            var test = /[\n\s+,，、/.。；;]/g;
            var oddnumber = newnumber.replace(test, " ");
            var oddnumberarr = oddnumber.split(" ");
            var temp = [];
            for (var i = 0; i < oddnumberarr.length; i++) {
                if (temp.indexOf(oddnumberarr[i]) == -1) {
                    temp.push(oddnumberarr[i]);
                }
            }

            var numbertest = /^[0-9]{12}$/;
            if (this.dynamicTags.length == 0) {
                temp = temp.slice(0, 10);
                for (let index = 0; index < temp.length; index++) {
                    if (numbertest.test(temp[index])) {
                        this.dynamicTags.push(temp[index]);
                        setTimeout(() => {
                            this.ruleForm.inputValue = "";
                        }, 100);
                    }
                }
            } else {
                let heightl = this.dynamicTags.length;
                let arrayheight = 10 - heightl;
                temp = temp.slice(0, arrayheight);
                for (let a = 0; a < temp.length; a++) {
                    if (this.dynamicTags.indexOf(temp[a]) == -1) {
                        if (numbertest.test(temp[a])) {
                            this.dynamicTags.push(temp[a]);
                            setTimeout(() => {
                                this.ruleForm.inputValue = "";
                            }, 100);
                        }
                    } else {
                        setTimeout(() => {
                            this.ruleForm.inputValue = "";
                        }, 100);
                    }
                }
            }
        },
        aueryfindbytype() {
            menuqueryaddressid({ name: "登录", sign: "1" }).then(res => {
                if (res.status == 2000) {
                    this.routerUrl = res.data.routAddress;
                }
            });
        },
        // banner下的ico点击跳转
        jumpPage(item) {
            let array = this.textmain;
            for (let index = 0; index < array.length; index++) {
                const element = array[index];
                if (element.title === item.title) {
                    var need = "";
                    if (
                        item.title !== "查物流" &&
                        item.title !== "查时效" &&
                        item.title !== "查网点" &&
                        item.title !== "在线下单"
                    ) {
                        need = "1";
                    }
                    if(item.title == '在线客服'){ // 在线客服需要登录
                        let islogin = sessionStorage.getItem("userInfoView");
                        if (islogin == null) {
                            sessionStorage.setItem("activeIndex", item.id);
                            window.open(
                                this.routerUrl + "/usercenter/login?successUrl=https%3A%2F%2Fwww.yimidida.com",
                                "_self"
                            );
                            return;
                        }
                    }
                    if (item.demoFlag == "/demoModel" && need === "1") {
                        let islogin = sessionStorage.getItem("userInfoView");
                        if (islogin == null) {
                            sessionStorage.setItem("activeIndex", item.id);
                            window.open(
                                this.routerUrl + "/demoModel?id=" + item.id,
                                "_self"
                            );
                            return;
                        }
                        this.$router.push({
                            path: element.demoFlag,
                            query: {
                                id: element.id
                            }
                        });
                    } else {
                        if (item.opennew !== "1") {
                            this.$store.dispatch("ParentList", "");

                            this.$router.push({
                                path: item.demoFlag,
                                query: {
                                    id: item.id
                                }
                            });
                        } else {
                            this.$store.dispatch("UpdateActive", item);
                        }
                    }
                }
            }
        },
        clienheight() {
            var height =
                window.innerHeight ||
                document.documentElement.clientHeight ||
                document.body.clientHeight;
            var width =
                window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            var merchant = height / width;
            if (merchant > 0.4 && merchant < 0.55) {
                this.innerheight = height;
            } else {
                this.innerheight = 940 / 1920 * width;
            }
        },
        edittag(data, indexs) {
            this.activeIndex = indexs;
            for (let index = 0; index < this.dynamicTags.length; index++) {
                if (this.dynamicTags[index] == data) {
                    this.tagsinnernum = index;
                }
            }
            this.inputhtml = data;
            this.getinputFocus();
        },
        save() {
            if (this.inputhtml == this.dynamicTags[this.tagsinnernum]) {
                this.dynamicTags[this.tagsinnernum] = this.inputhtml;
                this.activeIndex = 11;
            } else {
                this.editInputblur();
            }
            setTimeout(e => {
                this.getFocus();
            }, 200);
        },
        getinputFocus() { },
        getFocus() {
            this.$refs.saveTagInput.focus();
        },

        bannerquery() {
            homebannerquery({ platform: "1", isMobile: "1" })
                .then(res => {
                    if (res.status === 2000) {
                        this.list = res.data;
                    }
                })
                .catch(err => { });
        },
        homeActionquery() {
            homeAction({ platform: "1" })
                .then(res => {
                    if (res.status === 2000) {
                        this.textmain = res.data;
                    }
                })
                .catch(err => { });
        },
        recordhandleClose(tag) {
            this.recordlist.splice(this.recordlist.indexOf(tag), 1);

            let Waybilllist = this.recordlist.join(",");
            Cookies.set("Waybilllist", Waybilllist);
            if (this.recordlist.length == 0) {
                this.recordheight = 47;
            }

            this.getFocus();
        },

        watchInputblur() {
            //获取值
            let inputValuenow = this.ruleForm.inputValue;

            //校验
            var re = /^[0-9]{12}$/; //
            var numtest = /^(\d{11})([a-zA-Z]|；|;)$/;
            if (re.test(inputValuenow)) {
                if (this.dynamicTags.length > 10) {
                    this.$message({
                        message: "单号最多10条",
                        type: "warning"
                    });
                } else {
                    if (this.dynamicTags.length !== 0) {
                        if (this.dynamicTags.indexOf(inputValuenow) == -1) {
                            this.dynamicTags.push(inputValuenow);
                            setTimeout(() => {
                                this.ruleForm.inputValue = "";
                            }, 100);
                            this.getFocus();
                        } else {
                            this.$message({
                                message: "单号不能重复",
                                type: "warning"
                            });
                        }
                    } else {
                        this.dynamicTags.push(inputValuenow);
                        setTimeout(() => {
                            this.ruleForm.inputValue = "";
                        }, 100);
                        this.getFocus();
                    }
                }
            } else if (numtest.test(inputValuenow)) {
                inputValuenow = inputValuenow.substring(
                    0,
                    inputValuenow.length - 1
                );
                if (/^1(3|4|5|7|8)\d{9}$/.test(inputValuenow)) {
                    this.i = this.i + 1;
                    if (this.i > 1) {
                        this.$message({
                            message: "只能有一个电话号码",
                            type: "warning"
                        });

                        return;
                    }
                    this.dynamicTags.push(inputValuenow);
                    setTimeout(() => {
                        this.ruleForm.inputValue = "";
                    }, 100);
                    this.getFocus();
                } else {
                    this.$message({
                        message: "号码格式不正确",
                        type: "warning"
                    });
                    this.ruleForm.inputValue = inputValuenow.substring(
                        0,
                        inputValuenow.length - 1
                    );
                }
            } else {
                this.$message({
                    message: "请输入正确的格式",
                    type: "warning"
                });
            }
        },
        editInputblur() {
            //获取值
            let inputValuenow = this.inputhtml;

            //校验
            var re = /^[0-9]{12}$/; //
            var numtest = /^(\d{11})$/;
            if (re.test(inputValuenow) && inputValuenow.length == 12) {
                if (this.dynamicTags.length > 10) {
                    this.$message({
                        message: "单号最多10条",
                        type: "warning"
                    });
                } else {
                    if (this.dynamicTags.length !== 0) {
                        if (this.dynamicTags.indexOf(inputValuenow) == -1) {
                            this.dynamicTags[
                                this.tagsinnernum
                            ] = this.inputhtml;

                            this.i = 0;
                            this.activeIndex = 11;
                            return;
                        }
                        this.$message({
                            message: "单号不能重复",
                            type: "warning"
                        });
                    } else {
                        this.dynamicTags[this.tagsinnernum] = this.inputhtml;
                        this.activeIndex = 11;
                        this.i = 0;
                    }
                }
            } else if (
                numtest.test(inputValuenow) &&
                inputValuenow.length == 11
            ) {
                if (/^1(3|4|5|7|8)\d{9}$/.test(inputValuenow)) {
                    this.dynamicTags[this.tagsinnernum] = this.inputhtml;
                    this.activeIndex = 11;
                } else {
                    this.$message({
                        message: "号码格式不正确",
                        type: "warning"
                    });
                    return;
                }
            } else {
                this.$message({
                    message: "请输入正确的格式",
                    type: "warning"
                });
            }
        },
        original() {
            setTimeout(e => {
                if (
                    this.dynamicTags.length == 0 &&
                    this.ruleForm.inputValue == ""
                ) {
                    this.recordheight = 47;
                    this.recordshow = false;
                }
            }, 200);
        },
        handleInputConfirm() { },
        setSize: function () {
            if (this.screenWidth > 1400) {
                this.bannerHeight = 940 / 1920 * this.screenWidth;
                this.innerheight = this.bannerHeight;
            }
        },
        submitForm(formName) {
            let MenuQueryDto = { name: "查物流" };
            this.$refs[formName].validate(valid => {
                if (valid) {
                    //先去查询（查询货物地址）地址
                    menuqueryaddressid(MenuQueryDto).then(res => {
                        if (res.data) {
                            //将url拿出来，拼接参数
                            let Waybilllist;
                            let items=this.ruleForm.inputValue.replace( /[\n\s+,，、/.。；;]/g, ',');
                            let itemslist=items.split(',');
                            itemslist = [...new Set(itemslist)];
                            for (let index = 0; index < itemslist.length; index++) {
                                // debugger;
                                if(itemslist[index].length>15||itemslist[index].length<11){
                                    itemslist.splice(index,1);
                                }

                            }
                            if (Cookies.get("Waybilllist")) {
                                let historyarr = Cookies.get(
                                    "Waybilllist"
                                ).split(",");
                                let finalarr = historyarr.concat(
                                    itemslist
                                );
                                finalarr = [...new Set(finalarr)];
                                Waybilllist = finalarr.slice(-5).join(",");
                            } else {
                                if (itemslist.length < 6) {
                                    Waybilllist = itemslist.join(",");
                                } else {
                                    let tagsarr = itemslist.slice(-5);
                                    Waybilllist = tagsarr.join(",");
                                }
                            }
                            Cookies.set("Waybilllist", Waybilllist);
                            let url = res.data.routAddress;

                            let list = itemslist.join(",");
                            _hmt.push(['_trackEvent', '首页查运单', 'click','运单号查询轨迹']);
                            this.$router.push({
                                path: res.data.demoFlag,
                                query: {
                                    id: res.data.id,
                                    params: list
                                }
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        outin(number) {
            let MenuQueryDto = { name: "查货物" };
            //先去查询（查询货物地址）地址
            menuqueryaddressid(MenuQueryDto).then(res => {
                if (res.data) {
                    //将url拿出来，拼接参数
                    let url = res.data.routAddress;
                    res.data.routAddress = url + "?params=" + number;

                    this.$router.push({
                        path: res.data.demoFlag,
                        query: {
                            id: res.data.id,
                            params: number
                        }
                    });
                }
            });
        },
        enlarge() {
            if (!this.disabled) {
                this.inpheightTimeout = setInterval(() => {
                    this.codeheight += 1;
                    this.disabled = true;
                    if (this.codeheight > 45) {
                        clearInterval(this.inpheightTimeout);
                        this.inpheightTimeout = null;
                        this.disabled = false;
                    }
                }, 50);
            }
        },

        handleClose(tag, index) {
            this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);

            this.getFocus();

            if (tag.length == 11) {
                this.i = 0;
            }
        },
        handleSelect(item) {
            // 临时需求--给特定图片跳转特定地址
            if(item.image && item.image.indexOf('20240525034651.png') > 0){ // 捐款
                window.open("https://mp.weixin.qq.com/s/v2Y9w3GzTupSLZ_1BjY_6w");
            } else if(item.image && item.image.indexOf('20240530055324.png') > 0){ // 毕业季
                window.open("https://mp.weixin.qq.com/s/JHL_PsLisbYxkWN307Jsaw");
            } else if(item.image && item.image.indexOf('20240715050053.png') > 0){ // 问卷调查
                window.open("https://www.wjx.cn/vm/O0p1yQE.aspx");
            }else{
                item.id = item.routaddressid;

                if (item.opennew !== "1") {
                    this.$router.push({
                        path: item.demoFlag,
                        query: {
                            id: item.id
                        }
                    });
                } else {
                    this.$store.dispatch("UpdateActive", item);
                }
                this.$store.dispatch("BannerPath", item.routaddressid);
                this.$store.dispatch("ContentDescList", item.routaddressid);
                this.$store.dispatch("ContentDesc", item.routaddressid);
            }
        },
        recordenlarge() {
            setTimeout(e => {
                clearInterval(this.inpheightTimeout);
                if (!this.disabled) {
                    if (this.recordheight < 65) {
                        this.inpheightTimeout = setInterval(() => {
                            this.recordheight += 1;
                            this.disabled = true;
                            if (this.recordheight > 65) {
                                clearInterval(this.inpheightTimeout);
                                this.inpheightTimeout = null;
                                this.disabled = false;
                            }
                        }, 1);
                    }
                }
                this.recordshow = true;
                this.recoded = true;
            }, 200);
        },
        lose() {
            this.recordheight = 47;
        },
        conversion() { }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped lang="scss">
.TheMode {
    width: 100%;
    overflow: hidden;
    // height: 100%;
    position: relative;
    /deep/ .el-carousel {
        overflow: hidden;
        height: 100%;
        .el-carousel__indicators {
            position: absolute;
            bottom: 200px;
            .el-carousel__button {
                width: 16px;
                height: 16px;
                border-radius: 8px;
            }
        }
    }
    .swiper-container {
        width: 100%;
        // height: 100%;
        margin-left: auto;
        margin-right: auto;
        /deep/ .swiper-pagination {
            position: relative;
            bottom: 230px;
            .swiper-pagination-bullet {
                margin: 0 10px;
                width: 12px;
                height: 12px;
                opacity: 1;
                background-color: rgba(0, 0, 0, 0);
                border: 2px solid #fff;
            }
            .swiper-pagination-bullet-active {
                background-color: #f5f5f5;
            }
        }
        .swiper-wrapper {
            .swiper-slide {
                text-align: center;
                font-size: 18px;
                background: #fff;
                /* Center slide text vertically */
                display: -webkit-box;
                display: -ms-flexbox;
                display: -webkit-flex;
                display: flex;
                -webkit-box-pack: center;
                -ms-flex-pack: center;
                -webkit-justify-content: center;
                justify-content: center;
                -webkit-box-align: center;
                -ms-flex-align: center;
                -webkit-align-items: center;
                align-items: center;
                img {
                    width: 100%;
                    height: 100% !important;
                    .banner {
                        width: 100%;
                        height: 100% !important;
                        background-size: cover;
                    }
                }
            }
        }
    }
    .TheModeA {
        position: relative;

        /deep/ .el-input__inner {
            border-radius: 2px 0 0 2px;
            height: 100%;
            font-size: 16px;
        }
        /deep/ .el-icon-arrow-left,
        /deep/ .el-icon-arrow-right {
            font-size: 21px;
        }

        .absout {
            position: relative;
            .frame {
                // margin-bottom: 40px;
                width: 750px;
                position: absolute;
                bottom: 90px;
                left: 50%;
                transform: translateX(-50%);
                z-index: 2;
                padding-bottom: 3px;
                // margin-top: -144px;
                border-radius: 2px;
                background-color: rgba($color: #000000, $alpha: 0.5);
                .el-form {
                    margin: 15px 15px 0 15px;
                    .el-form-item {
                        margin-bottom: 20px;
                    }
                    .el-form-item__content {
                        height: 100%;
                    }
                    .el-form-item {
                        height: 100%;
                        /deep/ .fields {
                            display: inline-block;
                            width: 540px;
                            .bground {
                                position: relative;
                                background-color: #fff;
                                width: 100%;
                                height: 100%;
                                border-radius: 2px 0 0 2px;
                                overflow-y: auto;
                                // /deep/ .text {
                                //     height: 20px;
                                .red {
                                    color: red !important;
                                }
                                .green {
                                    color: green !important;
                                }
                                .el-tag {
                                    float: left;
                                    margin-top: 3px;
                                    border: 0px !important;
                                    background-color: #fff;
                                    height: 20px;
                                    font-size: 14px;
                                    line-height: 20px;
                                    color: #000;
                                    span {
                                        height: 20px;
                                        background-color: #ddd;
                                        border-radius: 9px;
                                        /* padding: 0 10px; */
                                        padding-left: 6px;
                                        padding-right: 18px;
                                    }
                                    .el-tag--mini {
                                        padding: 0 3px !important;
                                    }
                                    .el-icon-close {
                                        background-color: rgb(163, 154, 154);
                                        color: #fff;
                                        margin-left: -23px !important;
                                    }
                                    .el-icon-close:hover {
                                        background-color: #fabe00;
                                    }
                                    .inputtext {
                                        width: 100px;
                                        border: none;
                                        border-bottom: 1px dashed #ddd;
                                    }
                                    .inputtext:focus {
                                        outline: none;
                                    }
                                }
                                .el-tag--mini {
                                    padding: 0 3px;
                                }
                                .el-tag:nth-child(5) {
                                }
                                .el-tag + .el-tag {
                                    // margin-left: 6px !important;
                                }
                                .button-new-tag {
                                    margin-left: 6px;
                                    height: 16px !important;
                                    line-height: 16px !important;
                                    padding-top: 0;
                                    padding-bottom: 0;
                                }
                                // }
                                .recordcode {
                                    // opacity: 0.8;
                                    // margin-top: 5px;
                                    height: 23px;
                                    top: 4px;
                                    width: 90%;
                                    border: none;
                                    resize: none;
                                    outline: none;
                                    line-height: 23px;
                                    margin-left: 10px;
                                    .el-textarea__inner {

                                        resize: none;
                                        border: none;
                                        height: 48px;
                                        overflow: hidden;
                                        padding: 0;
                                        margin-top: 3px;
                                    }
                                    /deep/ .el-textarea {
                                        // opacity: 0.8;
                                        font-size: 16px;
                                        border: none;
                                        .el-textarea__inner {
                                            border: none;
                                            height: 100% !important;
                                        }
                                    }
                                }
                                .recodecord {
                                    // margin-top: 22px;
                                    height: 36px;
                                    // line-height: 45px;
                                    border: none !important;
                                    resize: none;
                                    overflow: hidden;
                                    outline: none;
                                    .el-textarea__inner {
                                        margin: 10px;
                                        background-color: rgba(0, 0, 0, 0);
                                        resize: none;
                                        border: none;
                                        color: #ddd;
                                        padding: 0;
                                    }
                                    // .el-input {
                                    //     height: 37px;
                                    /deep/ .el-textarea {
                                        // opacity: 0.8;
                                        font-size: 16px;
                                        height: 100%;
                                    }
                                    // .el-input__inner {
                                    //     border: 0px !important;
                                    //     font-size: 14px;
                                    //     color: #ddd;
                                    //     // margin-top: 9px;
                                    // }
                                    // }
                                }
                            }
                            .bgroundshouqi {
                                background-color: rgba(0, 0, 0, 0);
                                border: 1px solid #fabe00;
                                height: 45px;
                                .recodecord {
                                    .el-input__inner {
                                        background-color: rgba(0, 0, 0, 0);
                                        color: #ddd;
                                    }
                                }
                            }
                        }
                        .inlined {
                            display: inline-block;
                            width: 160px;
                            .yimidida {
                                position: relative;
                                top: -3px;
                            }
                            .el-icon-caret-right {
                                font-size: 22px;
                            }
                            .btn {
                                border-radius: 0 2px 2px 0;
                                height: 100%;
                                border: 1px solid #fabe00;
                                color: #fabe00;
                                border-color: #fabe00;
                                border-left: 0;
                                text-align: center;
                                background: -webkit-linear-gradient(
                                        left,
                                        #fabe00,
                                        #fabe00
                                    )
                                    no-repeat;
                                background: linear-gradient(
                                        to right,
                                        #fabe00,
                                        #fabe00
                                    )
                                    no-repeat;
                                background-size: 0% 100%;
                            }
                            .btn:hover {
                                background-size: 100% 100%;
                                color: #221418;
                            }
                        }
                    }
                }
                .iphone {
                    margin-left: 30px;
                    font-size: 14px;
                    color: #fff;
                    position: relative;
                    bottom: 7px;
                }
            }
            .frameshouqi {
                width: 763px;
                .el-form {
                    margin: 6px 6px 0 6px !important;
                    .el-form-item {
                        margin-bottom: 4px !important;
                    }
                }
            }
            .frameime {
                background-color: rgba($color: #000000, $alpha: 0) !important;
            }
        }
    }
    .record {
        position: absolute;
        bottom: 5px;
        left: 22px;
        // height: 36px;
        font-size: 13px;
        span {
            color: #fff;
        }
        p {
            color: #fff;
            display: inline-block;
            .el-tag {
                height: 20px;
                border: 0px;
                background-color: rgba(1, 1, 1, 0);
                color: #fff;
                padding: 0 10px 0 0;
                span {
                    cursor: pointer;
                    color: #fff;
                }
            }
        }
    }
    .line {
        position: relative;
        top: -70px;
        height: 70px;
        background-color: rgba(#000, 0.7);
        padding: 15px 0;
        z-index: 2;
        .el-icon-edit-outline {
            cursor: pointer;
            z-index: 9;
            font-size: 50px;
            position: absolute;
            bottom: 10px;
            right: 20px;
        }
        .el-col:nth-of-type(-n + 4) {
            box-sizing: border-box;
            border-right: 1px solid #f5f5f5;
            margin-left: -1px;
        }
        .ico {
            cursor: pointer;
            text-align: center;
            color: #fff;
            height: 70px;
            margin-top: -31px;
            .icon {
                visibility: hidden;
                line-height: 70px;
            }
            .bann {
                margin-top: 16px;
                width: 36px;
                height: 36px;
                position: relative;
                left: 32%;
                top: 16px;
                transform: translateX(-50%);
                margin-right: 15px;
                .iconimage {
                    width: 38px;
                    height: 38px;
                }
                .hoverimage {
                    width: 38px;
                    height: 38px;
                    display: none;
                }
            }
            .inLine {
                position: relative;
                bottom: 9px;
                left: 26px;
                font-size: 16px;
            }
        }
        .ico:hover {
            // .iconimage {
            // display: none;
            // }
            .iconimage {
                display: none;
            }
            .hoverimage {
                display: block;
            }
            background-color: #fff;
            color: #fabe00;
        }
    }
    .el-form-item.is-success .el-textarea__inner {
        border-color: none !important;
    }
    /deep/ .el-form-item__content {
        line-height: 0;
    }
}
</style>
